import SurveyQRRedirect from "./SurveyQRRedirect";

export default SurveyQRRedirect;
